module.exports = __webpack_public_path__ + "static/media/pending.1e76db84.webp";